// // src/pages/profile/AccountPage.js
// import React from "react";
// import { useAuth } from "../../Utility/AuthProvider"; // Adjust path if needed
// import CustomImage, { IMAGE_TYPES } from "../../Utility/CustomImage";

// const getInitials = (name = "") => {
//   if (!name) return "?";
//   return name
//     .split(" ")
//     .map((word) => word[0])
//     .slice(0, 2)
//     .join("")
//     .toUpperCase();
// };

// console.log("✅ AccountPage rendered!");

// const AccountPage = () => {
//   const { user } = useAuth();

//   if (!user) {
//     return <div>Loading user data...</div>;
//   }

//   return (
//     <div className="p-4 md:p-8 bg-gray-50 min-h-full">
//       <div className="max-w-4xl mx-auto">
//         <h1 className="text-3xl font-bold text-gray-800 mb-6">
//           Account Settings
//         </h1>
//         <div className="bg-white p-6 rounded-lg shadow-md">
//           <div className="flex flex-col sm:flex-row items-center gap-6 mb-8">
//             <CustomImage
//               location={user?.media?.profile_picture?.location}
//               className="w-24 h-24 rounded-full"
//               imageType={IMAGE_TYPES.PROFILE}
//               initials={getInitials(`${user.first_name} ${user.last_name}`)}
//               altText="Profile picture"
//             />
//             <div>
//               <h2 className="text-2xl font-semibold">{`${user.first_name} ${user.last_name}`}</h2>
//               <p className="text-gray-600">{user.user_type}</p>
//             </div>
//           </div>

//           <div className="space-y-4">
//             <div className="flex justify-between items-center border-b pb-2">
//               <span className="text-gray-600">First Name:</span>
//               <span className="font-medium text-gray-800">
//                 {user.first_name}
//               </span>
//             </div>
//             <div className="flex justify-between items-center border-b pb-2">
//               <span className="text-gray-600">Last Name:</span>
//               <span className="font-medium text-gray-800">
//                 {user.last_name}
//               </span>
//             </div>
//             <div className="flex justify-between items-center border-b pb-2">
//               <span className="text-gray-600">Email:</span>
//               <span className="font-medium text-gray-800">
//                 {user.email ? user.email : "Not Provided (optional field)"}
//               </span>
//             </div>
//             <div className="flex justify-between items-center">
//               <span className="text-gray-600">Mobile:</span>
//               <span className="font-medium text-gray-800">{`${user.country_code ? user.country_code : "+91"} ${user.mobile}`}</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AccountPage;

// AccountPage.js - Profile editing component
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../Utility/AuthProvider";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";

// const AccountPage = () => {
//   const navigate = useNavigate();
//   const { user, jwt, updateUserInContext } = useAuth();
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   // Form state
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     mobile: "",
//   });

//   // Debug log
//   console.log("📍 AccountPage rendered");
//   console.log("User data:", user);

//   // Initialize form with user data
//   useEffect(() => {
//     if (user) {
//       setFormData({
//         first_name: user.first_name || "",
//         last_name: user.last_name || "",
//         email: user.email || "",
//         mobile: user.mobile || "",
//       });
//     }
//   }, [user]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError("");
//     setSuccess("");

//     try {
//       console.log("📡 Updating user profile...");

//       const response = await APICall(
//         "PUT",
//         paths.user.update,
//         formData,
//         undefined,
//         jwt
//       );

//       console.log("📥 Update response:", response);

//       if (response && response.status === "success") {
//         setSuccess("Profile updated successfully!");

//         // Update user context with new data
//         if (updateUserInContext) {
//           updateUserInContext(formData);
//         }

//         // Navigate back to profile after short delay
//         setTimeout(() => {
//           navigate("/dashboard/profile");
//         }, 1500);
//       } else {
//         throw new Error(response?.message || "Failed to update profile");
//       }
//     } catch (err) {
//       console.error("❌ Error updating profile:", err);
//       setError(err.message || "An error occurred while updating your profile");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     navigate("/dashboard/profile");
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <div className="max-w-2xl mx-auto p-6">
//         {/* Header */}
//         <div className="mb-8">
//           <button
//             onClick={handleCancel}
//             className="flex items-center text-blue-600 hover:text-blue-700 mb-4"
//           >
//             <svg
//               className="w-5 h-5 mr-2"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M15 19l-7-7 7-7"
//               />
//             </svg>
//             Back to Profile
//           </button>

//           <h1 className="text-3xl font-bold text-gray-900 mb-2">
//             Account Settings
//           </h1>
//           <p className="text-gray-600">Update your personal information</p>
//         </div>

//         {/* Success Message */}
//         {success && (
//           <div className="mb-6 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg">
//             <div className="flex items-center">
//               <svg
//                 className="w-5 h-5 mr-2"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                 />
//               </svg>
//               {success}
//             </div>
//           </div>
//         )}

//         {/* Error Message */}
//         {error && (
//           <div className="mb-6 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">
//             <div className="flex items-center">
//               <svg
//                 className="w-5 h-5 mr-2"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                 />
//               </svg>
//               {error}
//             </div>
//           </div>
//         )}

//         {/* Profile Form */}
//         <div className="bg-white rounded-xl shadow-sm p-8">
//           <form onSubmit={handleSubmit} className="space-y-6">
//             {/* Profile Picture Section */}
//             <div className="flex items-center space-x-6 pb-6 border-b border-gray-200">
//               <div className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center overflow-hidden">
//                 {user?.media?.profile_picture?.location ? (
//                   <img
//                     src={user.media.profile_picture.location}
//                     alt="Profile"
//                     className="w-full h-full object-cover"
//                   />
//                 ) : (
//                   <svg
//                     className="w-10 h-10 text-blue-600"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                     />
//                   </svg>
//                 )}
//               </div>
//               <div>
//                 <h3 className="text-lg font-medium text-gray-900">
//                   Profile Picture
//                 </h3>
//                 <p className="text-sm text-gray-500">
//                   Update your profile photo
//                 </p>
//                 <button
//                   type="button"
//                   className="mt-2 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
//                   disabled
//                 >
//                   Change Photo (Coming Soon)
//                 </button>
//               </div>
//             </div>

//             {/* Personal Information */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label
//                   htmlFor="first_name"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   First Name<span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="first_name"
//                   name="first_name"
//                   value={formData.first_name}
//                   onChange={handleInputChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   required
//                 />
//               </div>

//               <div>
//                 <label
//                   htmlFor="last_name"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   Last Name<span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="last_name"
//                   name="last_name"
//                   value={formData.last_name}
//                   onChange={handleInputChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   required
//                 />
//               </div>
//             </div>

//             <div>
//               <label
//                 htmlFor="email"
//                 className="block text-sm font-medium text-gray-700 mb-1"
//               >
//                 Email Address
//               </label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleInputChange}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 required
//               />
//             </div>

//             <div>
//               <label
//                 htmlFor="mobile"
//                 className="block text-sm font-medium text-gray-700 mb-1"
//               >
//                 Mobile Number<span className="text-red-500">*</span>
//               </label>
//               <input
//                 type="tel"
//                 id="mobile"
//                 name="mobile"
//                 value={formData.mobile}
//                 onChange={handleInputChange}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                 required
//                 disabled
//               />
//               <p className="mt-1 text-sm text-gray-500">
//                 {/* Changing your mobile number may require verification */}
//                 Cannot change registered mobile number directly here. Please
//                 contanct support for assistance.
//               </p>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex items-center justify-end space-x-4 pt-6 border-t border-gray-200">
//               <button
//                 type="button"
//                 onClick={handleCancel}
//                 className="px-6 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 disabled={isLoading}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 disabled={isLoading}
//                 className="px-6 py-2 bg-blue-600 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 {isLoading ? (
//                   <div className="flex items-center">
//                     <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
//                     Saving...
//                   </div>
//                 ) : (
//                   "Save Changes"
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>

//         {/* Additional Account Options */}
//         {/* <div className="mt-8 bg-white rounded-xl shadow-sm p-6">
//           <h3 className="text-lg font-semibold text-gray-900 mb-4">
//             Account Security
//           </h3>
//           <div className="space-y-4">
//             <div className="flex items-center justify-between py-3 border-b border-gray-200">
//               <div>
//                 <h4 className="text-sm font-medium text-gray-900">
//                   Change Password
//                 </h4>
//                 <p className="text-sm text-gray-500">
//                   Update your account password
//                 </p>
//               </div>
//               <button
//                 type="button"
//                 className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
//                 disabled
//               >
//                 Change (Coming Soon)
//               </button>
//             </div>

//             <div className="flex items-center justify-between py-3 border-b border-gray-200">
//               <div>
//                 <h4 className="text-sm font-medium text-gray-900">
//                   Two-Factor Authentication
//                 </h4>
//                 <p className="text-sm text-gray-500">
//                   Add an extra layer of security
//                 </p>
//               </div>
//               <button
//                 type="button"
//                 className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
//                 disabled
//               >
//                 Enable (Coming Soon)
//               </button>
//             </div>
//           </div>
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default AccountPage;

import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Utility/AuthProvider";
import APICall, {
  GetUploadMediaBaseLocation,
  DeleteMedia,
} from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import CustomImage, { IMAGE_TYPES } from "../../Utility/CustomImage";
import { storage } from "../../Utility/firebase";
import { ref, uploadBytes, deleteObject } from "firebase/storage";
// import LinkedDevicesDialog from "./LinkedDevicesDialog"; // Import the new dialog
import LinkedDevicesDialog from "../../components/Modals/LinkedDevicesDialog";

// Cloud storage bucket paths
const cloudStorageBucket = {
  profilePicture: "user-profile-pictures/",
};

const AccountPage = () => {
  const navigate = useNavigate();
  const { user, jwt, updateUserInContext } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Linked Devices Dialog state
  const [isLinkedDevicesDialogOpen, setIsLinkedDevicesDialogOpen] =
    useState(false);

  // Form state
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
  });

  // Store original data to compare against
  const [originalData, setOriginalData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
  });

  // Profile picture state
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const fileInputRef = useRef(null);

  // Debug log
  console.log("📍 AccountPage rendered");
  console.log("User data:", user);

  // Initialize form with user data
  useEffect(() => {
    if (user) {
      const userData = {
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        email: user.email || "",
        mobile: user.mobile || "",
      };
      setFormData(userData);
      setOriginalData(userData); // Store original data
    }
  }, [user]);

  // Cleanup image preview URL on unmount
  useEffect(() => {
    return () => {
      if (imagePreviewUrl) {
        URL.revokeObjectURL(imagePreviewUrl);
      }
    };
  }, [imagePreviewUrl]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear success message when user starts typing again
    if (success) {
      setSuccess("");
    }
  };

  const handleImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith("image/")) {
        setError("Please select a valid image file");
        return;
      }

      // Validate file size (e.g., max 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        setError("Image size should be less than 5MB");
        return;
      }

      setSelectedImage(file);

      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setImagePreviewUrl(previewUrl);

      // Clear any previous errors
      setError("");
      setSuccess("");
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    if (imagePreviewUrl) {
      URL.revokeObjectURL(imagePreviewUrl);
      setImagePreviewUrl(null);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setUploadProgress(0);
  };

  // Helper function to create media data structure (similar to mobile's mediaData function)
  const createMediaData = (file, location, fileName) => {
    return {
      location: location,
      name: fileName || file.name,
      type: file.type,
      size: file.size,
      height: null, // These would be set if we read image dimensions
      width: null,
      description: "Profile picture",
    };
  };

  // Upload image to Firebase Storage
  const uploadImageToStorage = async () => {
    if (!selectedImage || !user?.entity_id) return null;

    try {
      // Generate unique filename
      const timestamp = Date.now();
      const fileExtension = selectedImage.name.split(".").pop();
      const fileName = `profile_${timestamp}.${fileExtension}`;

      // Create the storage location path
      const location = `${GetUploadMediaBaseLocation(cloudStorageBucket.profilePicture, user)}${user.entity_id}/${fileName}`;

      console.log("Uploading to Firebase Storage at location:", location);

      // Create a storage reference
      const storageRef = ref(storage, location);

      // Upload the file
      const uploadResult = await uploadBytes(storageRef, selectedImage, {
        contentType: selectedImage.type,
        customMetadata: {
          uploadedBy: user.entity_id,
          uploadedAt: new Date().toISOString(),
          originalName: selectedImage.name,
        },
      });

      console.log("Upload successful:", uploadResult);

      // Return the media data structure
      return createMediaData(selectedImage, location, fileName);
    } catch (error) {
      console.error("Error uploading image to Firebase Storage:", error);

      // Handle specific Firebase Storage errors
      if (error.code === "storage/unauthorized") {
        throw new Error(
          "You don't have permission to upload images. Please try logging in again."
        );
      } else if (error.code === "storage/canceled") {
        throw new Error("Upload was cancelled.");
      } else if (error.code === "storage/unknown") {
        throw new Error("An unknown error occurred. Please try again.");
      } else {
        throw new Error("Failed to upload image. Please try again.");
      }
    }
  };

  // Delete image from Firebase Storage
  const deleteImageFromStorage = async (location) => {
    if (!location) return;

    try {
      const storageRef = ref(storage, location);
      await deleteObject(storageRef);
      console.log(
        "Successfully deleted image from Firebase Storage:",
        location
      );
    } catch (error) {
      // If error is because object doesn't exist, that's okay
      if (error.code === "storage/object-not-found") {
        console.log("Image already deleted or doesn't exist:", location);
      } else {
        console.error("Error deleting image from Firebase Storage:", error);
        // Don't throw here, as we don't want to block the update process
      }
    }
  };

  // Email validation function
  const validateEmail = (email) => {
    if (!email) return true; // Empty email is valid (optional field)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Check if data has changed from original
  const hasDataChanged = useMemo(() => {
    return (
      formData.first_name !== originalData.first_name ||
      formData.last_name !== originalData.last_name ||
      formData.email !== originalData.email ||
      selectedImage !== null
    );
  }, [formData, originalData, selectedImage]);

  // Check if form is valid
  const isFormValid = useMemo(() => {
    return (
      formData.first_name.trim().length > 0 &&
      formData.last_name.trim().length > 0 &&
      validateEmail(formData.email)
    );
  }, [formData]);

  // Save button should be enabled only when data has changed AND form is valid
  const isSaveEnabled = hasDataChanged && isFormValid && !isLoading;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Double-check that we have changes and valid data
    if (!hasDataChanged || !isFormValid) {
      return;
    }

    setIsLoading(true);
    setError("");
    setSuccess("");

    try {
      console.log("📡 Updating user profile...");

      // Only send the fields that can be updated
      const updateData = {
        first_name: formData.first_name.trim(),
        last_name: formData.last_name.trim(),
        email: formData.email.trim(),
      };

      // Handle profile picture upload if selected
      let profilePictureData = null;
      if (selectedImage) {
        try {
          profilePictureData = await uploadImageToStorage();

          // Add media to update data
          const currentMedia = user?.media || {};
          updateData.media = JSON.stringify({
            ...currentMedia,
            profile_picture: profilePictureData,
          });
        } catch (uploadError) {
          console.error("Error uploading profile picture:", uploadError);
          throw new Error("Failed to upload profile picture");
        }
      }

      const response = await APICall(
        "PUT",
        paths.user.update,
        updateData,
        undefined,
        jwt
      );

      console.log("📥 Update response:", response);

      if (response && response.status === "success") {
        setSuccess("Profile updated successfully!");

        // Delete old profile picture if a new one was uploaded
        if (selectedImage && user?.media?.profile_picture?.location) {
          try {
            // First try to delete from Firebase Storage
            await deleteImageFromStorage(user.media.profile_picture.location);

            // Then notify the backend about the deletion
            await DeleteMedia(user.media.profile_picture.location, jwt);
            console.log("Old profile picture deleted successfully");
          } catch (deleteError) {
            console.error(
              "Error during profile picture deletion:",
              deleteError
            );
            // Don't throw here, as the update was successful
          }
        }

        // Update the original data to reflect the new saved state
        setOriginalData({
          ...originalData,
          first_name: updateData.first_name,
          last_name: updateData.last_name,
          email: updateData.email,
        });

        // Clear selected image
        handleRemoveImage();

        // Update user context with new data
        if (updateUserInContext) {
          const contextUpdate = {
            first_name: updateData.first_name,
            last_name: updateData.last_name,
            email: updateData.email,
          };

          if (profilePictureData) {
            contextUpdate.media = {
              ...user?.media,
              profile_picture: profilePictureData,
            };
          }

          updateUserInContext(contextUpdate);
        }

        // Navigate back to profile after short delay
        setTimeout(() => {
          navigate("/dashboard/profile");
        }, 1500);
      } else {
        throw new Error(response?.message || "Failed to update profile");
      }
    } catch (err) {
      console.error("❌ Error updating profile:", err);
      setError(err.message || "An error occurred while updating your profile");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    // Reset form data to original values
    setFormData(originalData);
    // Clear any selected image
    handleRemoveImage();
    navigate("/dashboard/profile");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-2xl mx-auto p-6">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={handleCancel}
            className="flex items-center text-blue-600 hover:text-blue-700 mb-4"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Back to Profile
          </button>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Account Settings
          </h1>
          <p className="text-gray-600">Update your personal information</p>
        </div>

        {/* Success Message */}
        {success && (
          <div className="mb-6 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg">
            <div className="flex items-center">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              {success}
            </div>
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div className="mb-6 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">
            <div className="flex items-center">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              {error}
            </div>
          </div>
        )}

        {/* Account Settings Card */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-6">
          {/* Linked Devices Option */}
          <div className="mb-8 pb-6 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Security</h3>
            <button
              onClick={() => setIsLinkedDevicesDialogOpen(true)}
              className="flex items-center justify-between w-full p-4 border border-gray-200 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <div className="flex items-center space-x-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div className="text-left">
                  <p className="font-medium text-gray-900">Linked Devices</p>
                  <p className="text-sm text-gray-500">
                    Manage devices where you're logged in
                  </p>
                </div>
              </div>
              <svg
                className="w-5 h-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>

          {/* Profile Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Profile Picture Section */}
            <div className="flex items-center space-x-6 pb-6 border-b border-gray-200">
              <div className="relative">
                <div className="w-20 h-20 rounded-full overflow-hidden">
                  {imagePreviewUrl ? (
                    // Show selected image preview
                    <div className="relative w-full h-full">
                      <img
                        src={imagePreviewUrl}
                        alt="Profile preview"
                        className={`w-full h-full object-cover ${isLoading && selectedImage ? "opacity-50" : ""}`}
                      />
                      {isLoading && selectedImage && (
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="bg-white bg-opacity-90 rounded-full p-2">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    // Show current profile picture or placeholder
                    <CustomImage
                      location={user?.media?.profile_picture?.location}
                      className="w-20 h-20 rounded-full"
                      imageType={IMAGE_TYPES.PROFILE}
                      altText="Profile picture"
                      initials={
                        user && formData.first_name && formData.last_name
                          ? `${formData.first_name[0]}${formData.last_name[0]}`.toUpperCase()
                          : ""
                      }
                    />
                  )}
                </div>
                {imagePreviewUrl && !isLoading && (
                  <button
                    type="button"
                    onClick={handleRemoveImage}
                    className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                    title="Remove image"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                )}
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900">
                  Profile Picture
                </h3>
                <p className="text-sm text-gray-500">
                  JPG, JPEG, PNG. Max size 5MB
                </p>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handleImageSelect}
                  className="hidden"
                  disabled={isLoading}
                />
                <button
                  type="button"
                  onClick={() => fileInputRef.current?.click()}
                  className="mt-2 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isLoading}
                >
                  {imagePreviewUrl ? "Change Photo" : "Upload Photo"}
                </button>
              </div>
            </div>

            {/* Personal Information */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label
                  htmlFor="first_name"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  First Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="first_name"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  disabled={isLoading}
                />
              </div>

              <div>
                <label
                  htmlFor="last_name"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Last Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="last_name"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  formData.email && !validateEmail(formData.email)
                    ? "border-red-300"
                    : "border-gray-300"
                }`}
                disabled={isLoading}
              />
              {formData.email && !validateEmail(formData.email) && (
                <p className="mt-1 text-sm text-red-600">
                  Please enter a valid email address
                </p>
              )}
            </div>

            <div>
              <label
                htmlFor="mobile"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Mobile Number<span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                required
                disabled
              />
              <p className="mt-1 text-sm text-gray-500">
                Cannot change registered mobile number directly here. Please
                contact support for assistance.
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center justify-end space-x-4 pt-6 border-t border-gray-200">
              <button
                type="button"
                onClick={handleCancel}
                className="px-6 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!isSaveEnabled}
                className={`px-6 py-2 border border-transparent rounded-md text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  isSaveEnabled
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
                title={
                  !hasDataChanged
                    ? "No changes made"
                    : !isFormValid
                      ? "Please fill all required fields correctly"
                      : ""
                }
              >
                {isLoading ? (
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Saving...
                  </div>
                ) : (
                  "Save Changes"
                )}
              </button>
            </div>
          </form>
        </div>

        {/* Show unsaved changes indicator */}
        {hasDataChanged && !success && (
          <div className="mt-4 text-sm text-amber-600 text-center">
            {selectedImage &&
            formData.first_name === originalData.first_name &&
            formData.last_name === originalData.last_name &&
            formData.email === originalData.email
              ? "You have selected a new profile picture"
              : "You have unsaved changes"}
          </div>
        )}
      </div>

      {/* Linked Devices Dialog */}
      <LinkedDevicesDialog
        isOpen={isLinkedDevicesDialogOpen}
        onClose={() => setIsLinkedDevicesDialogOpen(false)}
      />
    </div>
  );
};

export default AccountPage;
